import { render } from "./PromoSuggestionCard.vue?vue&type=template&id=786278e8&scoped=true"
import script from "./PromoSuggestionCard.vue?vue&type=script&lang=js"
export * from "./PromoSuggestionCard.vue?vue&type=script&lang=js"

import "./PromoSuggestionCard.vue?vue&type=style&index=0&id=786278e8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786278e8"]])

export default __exports__